/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeExpectedPaymentSettingGetResponseSchema } from './changeExpectedPaymentSettingGetResponseSchema.ts';

export const getChangeExpectedPaymentSettingQueryParamsSchema = z
  .object({
    reference: z.string().optional(),
  })
  .optional();

/**
 * @description 200 response
 */
export const getChangeExpectedPaymentSetting200Schema = z.lazy(() => changeExpectedPaymentSettingGetResponseSchema);

/**
 * @description 505 response
 */
export const getChangeExpectedPaymentSetting505Schema = z.any();

export const getChangeExpectedPaymentSettingQueryResponseSchema = z.lazy(
  () => getChangeExpectedPaymentSetting200Schema
);
